import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "../../../shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalFooter } from "../../../shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalBody } from "../../../shared/wrappers/FixaModal/FixaModalBody";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";

type Props = {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  isLoading?: boolean;
};

const DeleteConfirmationModal = ({
  visible,
  onConfirm,
  onCancel,
  title = "Delete Permission",
  message = "Are you sure you want to delete this permission?",
  isLoading = false,
}: Props) => {
  return (
    <FixaModal visible={visible} handleCloseBtn={onCancel}>
      <FixaSheets
        labelledById="feature-flags-delete-confirmation-modal-header"
        preserveAlignment={false}
        size="small"
        header={
          <FixaModalHeader
            id="feature-flags-delete-confirmation-modal-header"
            title={title}
            floating={false}
          />
        }
        footer={
          <FixaModalFooter>
            <FixaButton
              onClick={onCancel}
              type="secondary"
              disabled={isLoading}
            >
              No
            </FixaButton>
            <FixaButton onClick={onConfirm} type="primary" disabled={isLoading}>
              Yes
            </FixaButton>
          </FixaModalFooter>
        }
      >
        <FixaModalBody>
          <p>{message}</p>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};

export default DeleteConfirmationModal;
